import { HttpBadStatusCodeError, TPrimitives } from '@cian/peperrors/shared';

import { EOrigin } from '../../repositories/e2e-deal-entrypoints/entities/consultation_request/ConsultationRequestV1Schema';
import {
  fetchConsultationRequest,
  IConsultationRequestRequest,
  IConsultationRequestResponse200 as IRes200,
  IConsultationRequestResponse400 as IRes400,
} from '../../repositories/e2e-deal-entrypoints/v1/consultation-request';
import { TThunkAction } from '../../types/redux';
import { TRequestReturnValue } from '../../types/requestReturnValue';

/**
 * Отправка заявок на консультацию.
 *
 * NOTE Это ручка только для заявок на консультацию. Если нужно отправить другой тип заявки (например, запись на мастер-класс),
 * то нужно использовать другую ручку (например, e2e-deal-form/v2/leave-contacts/).
 */
export const sendConsultationRequest =
  (parameters: Omit<IConsultationRequestRequest, 'origin' | 'sentFrom'>): TThunkAction<Promise<TRequestReturnValue>> =>
  async (dispatch, getState, context) => {
    const userId = getState().user.userId;

    try {
      const result = await fetchConsultationRequest<IRes200, IRes400>({
        httpApi: context.httpApi,
        parameters: {
          ...parameters,
          sentFrom: 'Промо-страница для с-клиентов',
          origin: EOrigin.E2eDeal,
        },
      });

      if (result.statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          message: `${result.response.message}`,
          domain: 'sendConsultationRequest.ts',
          statusCode: result.statusCode,
          details: {
            errors: result.response.errors as TPrimitives,
          },
        });
      }

      return { data: undefined };
    } catch (error) {
      const isBasStatusCodeError = error instanceof HttpBadStatusCodeError;

      if (!isBasStatusCodeError) {
        context.logger.error(error, {
          message: 'Ошибка при отправке контактов, ручка e2e-deal-entrypoints/public/v1/consultation-request/',
          degradation: 'Ошибка в форме, пользователь может повторить попытку',
          domain: 'sendConsultationRequest.ts',
          details: { userId },
        });
      }

      return { error: new Error(isBasStatusCodeError ? error.message : undefined) };
    }
  };
